import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import Hls from 'hls.js'
import PropTypes from 'prop-types'
import React from 'react'

import * as actions from '../videoPlayer.actions'
import * as gameActions from '../../Game/game.actions'
import * as savePointSelectors from '../../SavePoint/savePoint.selectors'
import VideoControllers from '../VideoControllers'

/**
 *  Video tag abstraction.
 */
class Video extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)

    this.state = {
      paused: true,
      loading: true,
      loadedPercentage: 0,
      currentTime: 0,
      duration: 0,
    }
  }

  /**
   *  Component did mount.
   */
  componentDidMount() {
    const { isHls, url } = this.props
    if (!this.video) {
      return
    }

    if (isHls) {
      this.hls = new Hls()
      let url_rand = url + '?v=' + Math.floor(Math.random() * 99999999)
      this.hls.loadSource(url_rand)
      this.hls.attachMedia(this.video)
      this.hls.on(Hls.Events.FRAG_LOAD_PROGRESS, (_, data) => {
        const { stats } = data

        this.setState({
          duration: this.video.duration,
          loadedPercentage: (stats.loaded * 100) / stats.total,
        })
      })
    }

    this.onCanPlayListener = () => {
      this.onCanPlay()
    }
    this.onEndedListener = () => {
      this.onEnded()
    }
    this.onErrorListener = () => {
      this.onError()
    }
    this.onPlayingListener = () => {
      this.onPlaying()
    }
    this.onWaitingListener = () => {
      this.onWaiting()
    }
    this.video.addEventListener('canplaythrough', this.onCanPlayListener)
    this.video.addEventListener('ended', this.onEndedListener)
    this.video.addEventListener('error', this.onErrorListener)
    this.video.addEventListener('playing', this.onPlayingListener)
    this.video.addEventListener('waiting', this.onWaitingListener)
  }

  /***/
  componentDidUpdate() {
    this.state.currentTime >= this.state.duration ? this.finishCurrentTime() : null
  }
  /**
   *  Component will unmount.
   */
  componentWillUnmount() {
    this.hls && this.hls.destroy()
    this.hls = null

    this.video && this.video.removeEventListener('canplaythrough', this.onCanPlayListener)
    this.video && this.video.removeEventListener('ended', this.onEndedListener)
    this.video && this.video.removeEventListener('error', this.onErrorListener)
    this.video && this.video.removeEventListener('playing', this.onPlayingListener)
    this.video && this.video.removeEventListener('waiting', this.onWaitingListener)
    this.video = null
  }

  /**
   *  Fired when is possible to reproduce the video.
   */
  onCanPlay() {
    this.setState({ loading: false })
    this.video.play()
    this.state.interval ? null : this.updateCurrentTime()
  }

  /**
   *  Fired when video finish.
   */
  onEnded() {
    const { finishMediaPlayback, videoOptions, addAction } = this.props

    this.video.pause()
    this.finishCurrentTime()
    this.setState({ paused: true })

    if (videoOptions && videoOptions.action && videoOptions.action === 'stopNextScene') {
      addAction(videoOptions.action)
    } else {
      finishMediaPlayback()
    }
  }

  /**
   * Fired when some thing goes wrong.
   */
  onError() {
    this.onEnded()
  }
  /**
   *  Fired when the video begins or resumes.
   */
  onPlaying() {
    this.setState({ paused: false, loading: false })
  }

  /**
   *  Fired when
   *  @return  {[type]}  [description]
   */
  onWaiting() {
    this.setState({ loading: true })
  }

  updateCurrentTime() {
    let interval = setInterval(() => {
      this.setState({ currentTime: this.state.currentTime + 0.5 })
    }, 500)
    this.setState({ interval })
  }
  finishCurrentTime() {
    const { interval } = this.state
    clearInterval(interval)
  }
  /**
    rewind video
   */
  rewind() {
    const { paused } = this.state
    const timeRewind = '15'

    this.video.currentTime -= timeRewind
    this.setState({ currentTime: this.video.currentTime })
    paused ? this.updateCurrentTime() : null
  }
  /**
   *  Pause the video.
   */
  pause() {
    const { paused } = this.state

    if (paused) {
      this.video.play()
      this.updateCurrentTime()
    } else {
      this.video.pause()
      this.finishCurrentTime()
    }
    this.setState({ paused: !paused })
  }
  setTimePoint(client, width, pos) {
    const { interval } = this.state
    clearInterval(interval)
    console.log(((client - pos) / width) * this.video.duration)
    this.video.currentTime = ((client - pos) / width) * this.video.duration
    this.updateCurrentTime()
    this.setState({ currentTime: this.video.currentTime })
  }
  /**
   *  Skip de media.
   */
  skip() {
    this.onEnded()
  }

  /**
   *  Render component
   */
  render() {
    const { loadedPercentage, loading, paused, currentTime, duration } = this.state
    const { isHls, url, videoOptions, sceneId } = this.props

    if (!url) {
      return null
    }

    const playPause = paused
    const bigPlayBtn = paused ? 'icon-play' : 'display--none'

    const props = {
      ref: (video) => {
        this.video = video
      },
      src: isHls ? null : url,
      style: { height: '100%', width: '100%' },
    }
    const videoProps = {
      playPause: playPause,
      pause: () => {
        this.pause()
      },
      skip: () => {
        this.skip()
      },
      rewind: () => {
        this.rewind()
      },
      time: { currentTime: currentTime, duration: duration },
      setTimePoint: (client, width, pos) => {
        this.setTimePoint(client, width, pos)
      },
      videoOptions: videoOptions,
    }

    return (
      <div className="video">
        {videoOptions.classController != 'default-controllers' ? (
          <div className="video--header">
            <div className="video--header__title">
              <FormattedMessage id={`lessons.${sceneId}.title`} />
            </div>
            {videoOptions.skip || process.env.SKIP_VIDEO_ENABLED ? (
              <div
                className="icon-close"
                onClick={() => {
                  this.skip()
                }}
              ></div>
            ) : null}
          </div>
        ) : null}
        <div
          onClick={() => {
            this.pause()
          }}
          className={bigPlayBtn}
        ></div>
        <VideoControllers {...videoProps} />
        <video autoPlay {...props} />
        {loading ? (
          <div className={'video-loading-container'} style={{ top: 0, left: 0 }}>
            <div className={'video-loading-container-bg opacity-wrapper'} />
            <div className={'popup-alert warning'}>
              <div className={'popup-message'}>
                <p>
                  <FormattedMessage
                    id={'loading'}
                    values={{ percent: Math.floor(loadedPercentage) }}
                  />
                </p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Video.propTypes = {
  isHls: PropTypes.bool,
  url: PropTypes.string,
  videoOptions: PropTypes.object,
  sceneId: PropTypes.string,
  finishMediaPlayback: PropTypes.func,
  addAction: PropTypes.func,
}

const mapStateToProps = (state) => ({
  sceneId: savePointSelectors.getCurrentSceneId(state),
})

const mapDispatchToProps = (dispatch) => ({
  finishMediaPlayback: bindActionCreators(actions.finishMediaPlayback, dispatch),
  addAction: bindActionCreators(gameActions.addAction, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Video)
